<lib-dialog
  [title]="'service-selection-dialog.text.service-selection' | translate"
  (closeButtonClick)="closeDialog()"
>
  <div body class="content-container">
    <lib-salon-service-selection
      [businessObject]="businessObject"
      [selectedTime]="selectedTime"
      [originalSelectedProductIds]="originalSelectedProductIds"
      [disableSelectedProducts]="disableSelectedProducts"
      [formControl]="selectedProductIdControl"
    ></lib-salon-service-selection>
  </div>

  <ng-container action>
    <lib-spacer></lib-spacer>
    <button
      mat-flat-button
      color="primary"
      [disabled]="!isAbleToSave()"
      (click)="save()"
    >
      {{ 'service-selection-dialog.buttons.save' | translate }}
    </button>
    <lib-spacer></lib-spacer>
  </ng-container>
</lib-dialog>
